import { http } from '../index'

// 跟进记录类型定义
export interface StudentFollowRecord {
  id: number
  followable_type: string
  followable_id: number
  follow_type: number
  follow_result: number
  content: string
  customer_feedback?: string
  next_action?: string
  follow_time: string
  next_follow_time?: string
  duration?: number
  intention_level: number
  quoted_price?: number
  competitor?: string
  attachments?: any[]
  follow_admin_id: number
  created_at: string
  updated_at: string
  follow_admin: {
    id: number
    name: string
    avatar?: string
  }
  followable?: {
    id: number
    name: string
    phone: string
  }
}

// 跟进记录创建参数
export interface CreateFollowParams {
  follow_type: number
  follow_result: number
  content: string
  customer_feedback?: string
  next_action?: string
  follow_time?: string
  next_follow_time?: string
  duration?: number
  intention_level?: number
  quoted_price?: number
  competitor?: string
}

// 跟进记录更新参数
export interface UpdateFollowParams {
  follow_type?: number
  follow_result?: number
  content?: string
  customer_feedback?: string
  next_action?: string
  follow_time?: string
  next_follow_time?: string
  duration?: number
  intention_level?: number
  quoted_price?: number
  competitor?: string
}

// 跟进记录列表查询参数
export interface FollowListParams {
  page?: number
  per_page?: number
  follow_type?: number
  follow_result?: number
  intention_level?: number
  follow_admin_id?: number
  followable_type?: string
  followable_id?: number
  start_date?: string
  end_date?: string
  keyword?: string
}

// 跟进记录统计数据
export interface FollowStatistics {
  total: number
  today: number
  thisWeek: number
  thisMonth: number
}

// 学员线索跟进记录API
export const studentFollowRecordApi = {
  // 获取所有跟进记录列表
  getAllRecords: (params?: FollowListParams) => {
    return http.get('/admin/student-follow-records', { params })
  },

  // 获取跟进记录列表
  getList: (studentLeadId: number, params?: FollowListParams) => {
    return http.get(`/admin/student-leads/${studentLeadId}/follows`, { params })
  },

  // 创建跟进记录
  create: (studentLeadId: number, data: CreateFollowParams) => {
    return http.post(`/admin/student-leads/${studentLeadId}/follows`, data)
  },

  // 获取跟进记录详情
  getDetail: (id: number) => {
    return http.get(`/admin/student-follow-records/${id}`)
  },

  // 更新跟进记录
  update: (id: number, data: UpdateFollowParams) => {
    return http.put(`/admin/student-follow-records/${id}`, data)
  },

  // 删除跟进记录
  delete: (id: number) => {
    return http.delete(`/admin/student-follow-records/${id}`)
  },

  // 获取跟进类型选项
  getFollowTypes: () => {
    return http.get('/admin/student-follow-records/types')
  },

  // 获取跟进结果选项
  getFollowResults: () => {
    return http.get('/admin/student-follow-records/results')
  },

  // 获取意向等级选项
  getIntentionLevels: () => {
    return http.get('/admin/student-follow-records/intention-levels')
  },

  // 获取统计数据
  getStatistics: (params?: FollowListParams) => {
    return http.get('/admin/student-follow-records/statistics', { params })
  },
}
